import { staffListQueryFn, staffQueryKeys } from "@gymflow/api";
import { ApiType } from "@gymflow/common";
import {
  ApiListResponse,
  UserStaffBean,
  UserStaffTaskDTO,
} from "@gymflow/types";
import { InfiniteData, infiniteQueryOptions } from "@tanstack/react-query";
import useGymflowModels from "apps/portal/src/store";

import { OptionType } from "./components/OptionsList/components/OptionItem";
import { SelectInput, SelectInputProps } from "./SelectInput";

type StaffType = UserStaffBean | UserStaffTaskDTO;

export type StaffSelectInputOptionType = OptionType<StaffType>;

export type StaffSelectInputProps = {
  extraParams?: Parameters<ApiType["staffApi"]["find"]>[0]["extraParams"];
} & Omit<SelectInputProps<StaffType>, "dataFetchingQuery">;

/**
 * @deprecated remove this component and move the internal logic to `FormSelectStaff`
 */
export const StaffSelectInput = ({
  extraParams,
  ...props
}: StaffSelectInputProps) => {
  const { api } = useGymflowModels();

  return (
    <SelectInput
      {...(props as SelectInputProps<StaffType>)}
      dataFetchingQuery={() =>
        infiniteQueryOptions({
          queryKey: staffQueryKeys.list(),
          queryFn: async ({ pageParam }) =>
            await staffListQueryFn({
              api,
              opts: {
                extraParams: extraParams ? extraParams : { activeUser: true },
                page: pageParam,
                limit: 50,
              },
            }),
          select: (data) => {
            const { pageParams, pages } = data as InfiniteData<
              ApiListResponse<UserStaffBean>
            >;

            const transformedPages = pages.map((page) =>
              page.content.map((staff) => ({
                id: staff.id,
                label: `${staff.firstName} ${staff.lastName}`,
                value: staff,
                imageUrl: staff.picture,
                subLabel: staff.email,
              })),
            );

            return {
              pageParams,
              pages: transformedPages,
            };
          },
          getNextPageParam: (lastPage) => {
            const typedLastPage = lastPage as ApiListResponse<UserStaffBean>;
            return typedLastPage.last ? undefined : typedLastPage.number + 1;
          },
          initialPageParam: 0,
        })
      }
    />
  );
};
